import { render, staticRenderFns } from "./LocationsImagesList.vue?vue&type=template&id=3edb8a33"
import script from "./LocationsImagesList.vue?vue&type=script&lang=js"
export * from "./LocationsImagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports